import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AutenticarCandidato, Candidato } from '@app/models/sisrh.model';
import { SisrhService } from '@app/services/sisrh.service';
import { LgpdService } from './lgpd.service';

@Injectable({
  providedIn: 'root'
})
export class AutenticacaoService {

  public token: any;
  private usuarioAtualCandidatoSubject: BehaviorSubject<Candidato>;
  usuarioAtualCandidato: Observable<Candidato>;

  constructor(
    private sisrhService: SisrhService,
    private lgpdService: LgpdService
    ) {

    let usuarioAtualCandidatoValue = localStorage.getItem('usuarioAtualCandidato');
    usuarioAtualCandidatoValue = usuarioAtualCandidatoValue === 'undefined' ? null : usuarioAtualCandidatoValue;

    this.usuarioAtualCandidatoSubject = new BehaviorSubject<Candidato>(JSON.parse(usuarioAtualCandidatoValue));
    this.usuarioAtualCandidato = this.usuarioAtualCandidatoSubject.asObservable();

  }

  get getValorUsuarioAtualCandidato(): Candidato {

    return this.usuarioAtualCandidatoSubject.value;

  }

  setValorUsuarioAtualCandidato(candidato: Candidato, token: string) {

    localStorage.setItem('usuarioAtualCandidato', JSON.stringify(candidato));
    localStorage.setItem('candidatoUser', btoa(JSON.stringify(token)));
    this.usuarioAtualCandidatoSubject.next(candidato);

  }

  getTokenCandidato(){
    return localStorage.getItem('candidatoUser') ? JSON.parse(atob(localStorage.getItem('candidatoUser'))) : null;
  }
  login(autenticarCandidato: AutenticarCandidato): Observable<any> {
    return this.sisrhService.autenticar(autenticarCandidato)
      .pipe(
        map(x => {
          if (x.success) {
            this.setValorUsuarioAtualCandidato(x.data, x.token);
          }
          return x;
        })
      );
  }

  verificarTermoUsuario(cpf, siglaSistema, siglaTermo): Observable<any> {
    return this.lgpdService.verificarTermoUsuario(cpf, siglaSistema, siglaTermo)
    .pipe(
      map(x => {
        return x;
      })
    );
  }

  logout() {
    localStorage.removeItem('usuarioAtualCandidato');
    localStorage.removeItem('candidatoUser');
    this.usuarioAtualCandidatoSubject.next(null);
  }

}
